import Navbar from "./navbar";
import Footer from "./footer";
import * as Icon from "react-feather";
import { useParams } from "react-router-dom";
import axios from "axios";
import React from "react";
import { TicketingApiUri, apiKey } from "../constants";
import { NotifWrapper } from "./Notif";
import LayoutContext from "./LayoutContext";

export default function Layout({ children, fsMode, ...props }) {
  const { eventid, vendorid } = useParams();
  const [eventData, setEventData] = React.useState({});
  const [isEventOver, setIsEventOver] = React.useState(false);

  const [runningNotifs, setRunningNotifs] = React.useState([]);
  // const [vendorData, setVendorData] = React.useState({});

  const { runningNotifsNew, setRunningNotifsNew } = React.useContext(LayoutContext);

  React.useEffect(() => {
    async function getEventData(event_id) {
      let responseEvent = null;

      try {
        responseEvent = await axios.get(
          TicketingApiUri +
            "readevent.php?apikey=" +
            apiKey +
            "&eventID=" +
            event_id
        );
      } catch (error) {
        responseEvent = error.response;
      } finally {
        console.log(responseEvent.data);

        if (responseEvent.data.status !== "200") {
          // handle error
        }

        setEventData(responseEvent.data);
      }
    }

    async function getVendorData(vendor_id) {
      let responseVendor = null;

      try {
        responseVendor = await axios.get(
          TicketingApiUri +
            "readvendor.php?apikey=" +
            apiKey +
            "&vendorID=" +
            vendor_id
        );
      } catch (error) {
        responseVendor = error.response;
      } finally {
        console.log(responseVendor.data);

        if (responseVendor.data.status !== "200") {
          // handle error
        }

        // setVendorData(responseVendor.data);

        // setEventData(responseEvent.data);
        getEventData(responseVendor.data.vendors.eventID);
      }
    }

    if (vendorid !== undefined) {
      getVendorData(vendorid);
    } else if (eventid !== undefined) {
      getEventData(eventid);
    }
  }, [eventid, vendorid]);

  React.useEffect(() => {
    if (eventData.events === undefined) return;

    let currDate = new Date();
    let eventDate = new Date(eventData.events.timeEnd * 1000);

    // check to see if the event is over
    if (currDate > eventDate) {
      setIsEventOver(true);
    }
  }, [eventData]);

  function handleAddNotif(notif) {
    // set random id to notif
    notif.id = Math.random().toString(36).substr(2, 9);

    setRunningNotifs((prev) => [...prev, notif]);
  }

  // const childrenWithProps = React.Children.map(children, (child) => {
  //   return React.cloneElement(child, { handleAddNotif: handleAddNotif });
  // });

  const childrenWithProps = React.Children.map(children, (child) => {
    // checking if this is a valid react element
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { handleAddNotif: handleAddNotif });
    }
    return child;
  });

  return (
    <div className="flex flex-col min-h-screen min-w-screen">
      <Navbar />
      {isEventOver ? (
        <div className="flex flex-col w-full justify-start items-center overflow-y-hidden">
          <div className="w-full">
            <div className="w-full h-[80px]"></div>
            <section className="fixed flex w-full flex-col space-y-2 rounded-xl z-[25] -translate-y-[80px]">
              <div className="flex flex-col p-4 space-y-1 justify-between bg-blue-100">
                <div className="flex flex-row space-x-1 items-center">
                  <Icon.Info className="text-blue-800" size={20} />
                  <h2 className="text-md font-bold text-blue-800">
                    This Event is Now Over
                  </h2>
                </div>
                <h2 className="text-sm font-normal text-blue-800 p-0 mt-0">
                  This event is archived, and is now in read-only mode.
                </h2>
              </div>
            </section>
          </div>
        </div>
      ) : null}

      {/* <main
        className={
          "flex flex-col " +
          (isEventOver
            ? "md:h-[calc(100vh-210px)] lg:h-[calc(100vh-150px)]"
            : "md:h-[calc(100vh-130px)] lg:h-[calc(100vh-70px)]")
        }
      >
        {childrenWithProps}
      </main> */}
      <main className="flex flex-col grow">{childrenWithProps}</main>
      {/* <main className="flex flex-col grow">{children}</main> */}

      <NotifWrapper
        runningNotifs={runningNotifs}
        setRunningNotifs={setRunningNotifs}
      />
      <NotifWrapper
        runningNotifs={runningNotifsNew}
        setRunningNotifs={setRunningNotifsNew}
      />
      {fsMode ? null : (
        <Footer />
      )}
    </div>
  );
}
